<template>
	<header class="container">    
		<div class="row">
			<div class="col-12">
				<div class="d-flex justify-content-center text-center font-monospace pt-3 mb-3">
					<div class=" _text_btn mx-2" @click="modal.open()">
						<span v-if="!isConnected">Connect wallet</span>
						<span v-if="isConnected">{{ $filters.addressShort(address) }}</span>
					</div>					
				</div>
			</div>
		</div>			
	</header>			
</template>

<style lang="scss" scoped>
    @import "@/scss/variables";    
	header {		
		z-index: 1;
		._logo {
			img {
				width: 115%;
				&._mobile { 
					width: 75%;
				}
			}
		}
		._nav_btn {
			cursor: pointer;
			transition: .25s ease-in-out;
			&:hover{ 
				transform: scale(1.1);
				filter: brightness(1.1);
			}
			&._play {
				img {
					max-width: 300px;
				}
			}
		}
		._text_btn {
			cursor: pointer;
			color: $_block_bg_color;
			font-size: 1.2rem;
			font-weight: 700;
			transition: .15s ease-in-out;
			border: 1px solid $_block_bg_color;
			background: rgba($_block_bg_color, .1);
			border-radius: 10rem;
			padding: 0rem 1rem;
			&:hover{ 
				transform: scale(1.1);
				filter: brightness(1.1);
			}	
			&.active {
				color: $_text-color;
				background: rgba($_block_bg_color, .9);
			}		
		}
  	}  		   
</style>

<script setup>
	import { useWeb3Modal } from '@web3modal/ethers5/vue'
	import { useWeb3ModalAccount } from '@web3modal/ethers5/vue'
	const { address, isConnected } = useWeb3ModalAccount()  
	const modal = useWeb3Modal() 
</script>
